import {
    BASKET_SCOPE_DEV,
    BASKET_SCOPE_PROD,
    BASKET_SCOPE_QA,
    DEFAULT_POLICY,
    OAuthTokenScopes,
    WZ_SCOPE_DEV,
    WZ_SCOPE_PROD,
    WZ_SCOPE_QA,
} from '@os-components';

export const authDev: OAuthTokenScopes = {
    clientId: 'b96ccfbb-3a86-4617-9f89-ab016c76771d',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_DEV, WZ_SCOPE_DEV],
};
export const authQa: OAuthTokenScopes = {
    clientId: '6b8e4d6f-043d-4527-8c8a-e6a03824e6a5',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_QA, WZ_SCOPE_QA],
};

export const authProd: OAuthTokenScopes = {
    clientId: 'f794b685-69af-40e5-b52e-f215d158e1bb',
    policy: DEFAULT_POLICY,
    scopes: [BASKET_SCOPE_PROD, WZ_SCOPE_PROD],
};
